import React, { useState } from 'react';
import Button from 'src/components/atoms/button/Button';
import InputForm from 'src/components/atoms/form/InputForm';
import ErrorMessage from 'src/components/atoms/form/ErrorMessage';

interface Props {
  handleLogin: Function;
  errorMessage: string;
}

const LoginForm = ({ ...props }: Props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const canSubmit = email && password ? true : false;
  const isError = props.errorMessage.length > 0;
  return (
    <form>
      <div style={{ margin: '8px 0' }}>
        <InputForm
          inputType={'text'}
          inputValue={email}
          onChange={setEmail}
          autoComplete={'username'}
          placeholder={'メールアドレス'}
          isError={isError}
        />
      </div>
      <div style={{ margin: '8px 0' }}>
        <InputForm
          inputType={'password'}
          inputValue={password}
          onChange={setPassword}
          placeholder={'パスワード'}
          autoComplete={'current-password'}
          isError={isError}
        />
      </div>
      <Button
        isDisabled={!canSubmit}
        type={'button'}
        clickEvent={() => {
          props.handleLogin({ email, password });
        }}
        text={'ログイン'}
      />
      {isError ? <ErrorMessage marginVertical={8}>{props.errorMessage}</ErrorMessage> : null}
    </form>
  );
};

export default LoginForm;
